import { wave } from '../waves';
import type { HazardSystem } from '../hazards';

interface WaveClearDeps {
  hazards: HazardSystem;
  triggerZoom(dur?: number): void;
  triggerWipe(dur?: number): void;
}

// Fired from the wave.cleared callback. Handles the visual+spawn ceremony when a wave ends:
// hazard cleanup, possible random black-hole spawn next wave, GRAVITY-arena center BH,
// boss-entry zoom, RGB-split wipe, arena banner.
export function runWaveClearCeremony(n: number, deps: WaveClearDeps, W: number, H: number): void {
  deps.hazards.clearForWaveBreak();
  // Random black-hole spawn on the next non-boss wave (45%, wave 4+)
  const next = n + 1;
  if (next >= 4 && next % 5 !== 0 && Math.random() < 0.45) {
    deps.hazards.spawnBlackHole(W, H);
  }
  // Boss arena GRAVITY: center black hole for the boss wave
  if (next % 5 === 0 && wave.bossArena === 'GRAVITY') {
    deps.hazards.spawnBlackHole(W, H, true);
  }
  // Boss-wave entry zoom
  if (next % 5 === 0) {
    deps.triggerZoom(0.6);
  }
  deps.triggerWipe(0.55);
  // Boss arena banner — tells the player which modifier this wave will run under
  if (next % 5 === 0 && wave.bossArena) {
    const arenaColors: Record<string, number> = {
      GRAVITY: 0x8855ff, MIRROR: 0xff44ff, DARKNESS: 0x666688, MINIONS: 0xffaa44,
    };
    const arenaLabels: Record<string, string> = {
      GRAVITY: 'GRAVITÉ', MIRROR: 'MIROIR', DARKNESS: 'OBSCURITÉ', MINIONS: 'SBIRES',
    };
    wave.banner = {
      text: `ARÈNE ${arenaLabels[wave.bossArena] ?? wave.bossArena}`,
      color: arenaColors[wave.bossArena] ?? 0xffffff,
      t: 130,
    };
  }
}
